import { gradeOptions } from "@/data/panels";

export interface Profile {
  removed_at?: string | null;
  id: string;
  user_id: string | null;
  email: string | null;
  full_name: string | null;
  role: string | null;
  grade: string | null;
  city: string | null;
  birth_date: string | null;
  target_exam: string | null;
  created_at: string;
}

export const ROLE_META: Record<string, { label: string; badge: string; icon: string }> = {
  ogrenci: {
    label: "Öğrenci",
    badge: "bg-primary-100 text-primary-800",
    icon: "ri-graduation-cap-line",
  },
  veli: {
    label: "Veli",
    badge: "bg-accent-100 text-accent-800",
    icon: "ri-heart-3-line",
  },
  ogretmen: {
    label: "Öğretmen",
    badge: "bg-secondary-100 text-secondary-900",
    icon: "ri-user-star-line",
  },
  admin: {
    label: "Yönetici",
    badge: "bg-foreground-100 text-foreground-700",
    icon: "ri-shield-keyhole-line",
  },
};

export const ROLE_OPTIONS: { value: string; label: string }[] = [
  { value: "ogrenci", label: "Öğrenci" },
  { value: "veli", label: "Veli" },
  { value: "ogretmen", label: "Öğretmen" },
  { value: "admin", label: "Yönetici" },
];

export const GRADE_OPTIONS: string[] = gradeOptions;

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString("tr-TR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 1).toLocaleUpperCase("tr-TR");
  return (parts[0][0] + parts[parts.length - 1][0]).toLocaleUpperCase("tr-TR");
}
